import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    NumberInput,
    BooleanInput,
    DateField,
    Filter,
    ReferenceInput,
    ReferenceField,
    DeleteButton,
} from 'react-admin';

const ExamFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索标题" source="key" alwaysOn />
        <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
            <SelectInput optionText="Title" />
        </ReferenceInput>
        <SelectInput source="Status" label="状态" choices={[
            { id: 1, name: '已发布' },
            { id: 0, name: '草稿' },
        ]} />
    </Filter>
);

export const ExamList = props => (
    <List {...props} filters={<ExamFilter />} title="考试管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="考试标题" />
            <ReferenceField source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <TextField source="Title" />
            </ReferenceField>
            <TextField source="TotalScore" label="总分" />
            <TextField source="PassScore" label="及格分" />
            <TextField source="TimeLimit" label="时长(分钟)" />
            <TextField source="ActualQuestionCount" label="题目数" />
            <TextField source="Status" label="状态" />
            <DateField source="CreateTime" label="创建时间" showTime />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const ExamEdit = props => (
    <Edit {...props} title="编辑考试">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="考试标题" fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Description" label="考试说明" multiline fullWidth />
            <NumberInput source="TotalScore" label="总分" />
            <NumberInput source="PassScore" label="及格分" />
            <NumberInput source="TimeLimit" label="考试时长(分钟)" />
            <BooleanInput source="IsRandom" label="随机出题" />
            <NumberInput source="QuestionCount" label="随机题数" />
            <NumberInput source="AllowTimes" label="允许考试次数(0不限)" />
            <BooleanInput source="ShowAnalysis" label="显示答案解析" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const ExamCreate = props => (
    <Create {...props} title="新建考试">
        <SimpleForm>
            <TextInput source="Title" label="考试标题" fullWidth />
            <ReferenceInput source="CourseId" reference="Admin/CMSCourse" label="关联课程" allowEmpty>
                <SelectInput optionText="Title" />
            </ReferenceInput>
            <TextInput source="Description" label="考试说明" multiline fullWidth />
            <NumberInput source="TotalScore" label="总分" defaultValue={100} />
            <NumberInput source="PassScore" label="及格分" defaultValue={60} />
            <NumberInput source="TimeLimit" label="考试时长(分钟)" defaultValue={60} />
            <BooleanInput source="IsRandom" label="随机出题" defaultValue={false} />
            <NumberInput source="QuestionCount" label="随机题数" defaultValue={0} />
            <NumberInput source="AllowTimes" label="允许考试次数(0不限)" defaultValue={0} />
            <BooleanInput source="ShowAnalysis" label="显示答案解析" defaultValue={true} />
            <SelectInput source="Status" label="状态" defaultValue={0} choices={[
                { id: 1, name: '已发布' },
                { id: 0, name: '草稿' },
            ]} />
        </SimpleForm>
    </Create>
);
